import React from 'react'
import ContrastModeSelector from '@/components/roi/ContrastModeSelector'
import { useAdmobDatePickerStore } from '@/stores/admob-store'

/**
 * Admob 模块的对比模式选择器适配器
 * 传递 useAdmobDatePickerStore 给 ContrastModeSelector
 */
const AdmobContrastModeSelector = ({ className }) => {
  return (
    <ContrastModeSelector 
      className={className} 
      datePickerStore={useAdmobDatePickerStore}
    />
  )
}

export default AdmobContrastModeSelector
